import { SafeImage } from '@/ui';
import { validateImage } from '@lib';
import type { APIImageType } from '@types';
import { clsx } from 'clsx';

export function Background({
  size,
  image,
  opacity = '0.25',
}: {
  size: 'sm' | 'md' | 'lg';
  image: APIImageType | Array<APIImageType>;
  opacity?: string;
}) {
  let className = '';
  let opacityValue = 0.25;
  switch (size) {
    case 'sm':
      className = 'top-1/3 right-0 translate-x-1/2 size-[max(75vw,75vh)]';
      opacityValue = parseFloat(opacity) * 1.25;
      break;
    case 'md':
      className = 'top-3/4 right-0 translate-x-1/2 size-[max(100vw,100vh)]';
      opacityValue = parseFloat(opacity);
      break;
    case 'lg':
      className = 'top-1/2 left-0 -translate-x-1/2 size-[max(125vw,125vh)]';
      opacityValue = parseFloat(opacity) * 0.75;
      break;
  }

  if (!validateImage(image)) return null;

  return (
    <div
      className={clsx('pointer-events-none absolute z-10 flex max-w-none -translate-y-1/2 opacity-25', className)}
      style={{
        opacity: opacityValue,
      }}
    >
      <SafeImage className="object-contain" src={image} sizes={'150vw'} fill />
    </div>
  );
}
